/**
 * Created by rhett on 2019/4/11.
 */

import React, {Component} from 'react';
import "./CurActivityLi.css";
import {Link} from "react-router-dom";

export default class CurActivityLi extends Component
{


  componentDidMount()
  {
  }

  render()
  {
    let {id}  = this.props;
    return (
      <Link className="CurActivityLi" to={`./detail-${id}`}>

        <img src={this.props.img} alt="" className="cover"/>
        <div className="title">{this.props.title}</div>
        <div className="desc">{this.props.desc}</div>
        <div className="btn"   >
          免费报名
        </div>
      </Link>);
  }


}